'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = topicDictionaryFactory;

var _subscription = require('../../utils/subscription');

var _subscription2 = _interopRequireDefault(_subscription);

var _cachedValue = require('../../utils/cachedValue');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function topicDictionaryFactory() {
    var topicDictionary = (0, _cachedValue.dictionary)(function () {
        var subsr = (0, _subscription2.default)();
        subsr.setSubscription({
            close: function close(reason) {
                subsr.emit('close', reason);
            }
        });
        return subsr;
    });
    topicDictionary.update = function (topic, value) {
        topicDictionary.getValue(topic).onUpdate(value, topic);
    };
    return topicDictionary;
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/stub/topicDictionaryFactory.js
// module id = 1866
// module chunks = 1